// Optimizely Experiment Setup to Test the New Onboard Flow for Invitations Only
export const testInvitationsOnboardOptimizelyConfig = {
  // The variation represenst the Original Onboard Flow, so if it is found, show the original onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_new_onboard_invitations',
    experimentId: '13638660175',
    variationId: '13623600156'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_new_onboard_invitations',
    experimentId: '13634440711',
    variationId: '13623590175'
  }
};

export const weddingDashboardEditorialWithNoDekOptimizelyConfig = {
  // The variation represenst the Original Onboard Flow, so if it is found, show the original onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_wedding_dashboard_editorial_no_dek',
    experimentId: '13645020554',
    variationId: '13654680665'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_wedding_dashboard_editorial_no_dek',
    experimentId: '13662300568',
    variationId: '13652700571'
  }
};

// Variation A - Invites Redirect publish flow
export const testPublishWebsiteInviteRedirectVariationA = {
  554664308: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13640090411',
    variationId: '13670740198'
  },
  // Production
  566520915: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13848220237',
    variationId: '13831080255'
  }
};

// Variation B - Invites Redirect publish flow
export const testPublishWebsiteInviteRedirectVariationB = {
  // staging
  554664308: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13640090411',
    variationId: '13680310582'
  },
  // Production
  566520915: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13848220237',
    variationId: '13841010402'
  }
};



// WEBPACK FOOTER //
// ./src/util/optimizelyConfigs.js